import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation7({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [stars, setStars] = useState<number[]>([])

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 300)

    // Créer des étoiles qui explosent
    const starCount = 20
    const starArray = Array.from({ length: starCount }, (_, i) => i)
    setStars(starArray)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes starBurst {
          0% {
            transform: translate(0, 0) rotate(0deg) scale(0);
            opacity: 0;
          }
          20% {
            opacity: 1;
            transform: translate(var(--tx), var(--ty)) rotate(180deg) scale(1);
          }
          100% {
            transform: translate(calc(var(--tx) * 3), calc(var(--ty) * 3)) rotate(360deg) scale(0);
            opacity: 0;
          }
        }
        .star {
          animation: starBurst 2s ease-out forwards;
        }
        @keyframes twinkle {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.2); }
        }
        .twinkle {
          animation: twinkle 0.3s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Étoiles qui explosent */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {stars.map((index) => {
            const angle = (index / stars.length) * 360
            const radians = (angle * Math.PI) / 180
            const distance = 100 + Math.random() * 50
            const tx = Math.cos(radians) * distance
            const ty = Math.sin(radians) * distance

            return (
              <div
                key={index}
                className="star absolute text-tessan-yellow"
                style={{
                  '--tx': `${tx}px`,
                  '--ty': `${ty}px`,
                  animationDelay: `${index * 0.05}s`
                } as React.CSSProperties}
              >
                <span className="text-2xl">⭐</span>
              </div>
            )
          })}
        </div>

        {/* Badge central */}
        <div className={`relative z-10 transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="relative twinkle">
            <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
              <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
            </div>
          </div>

          <div className="mt-6 text-center">
            <div className="text-2xl sm:text-4xl font-black text-tessan-yellow twinkle">{badge.name}</div>
            <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
            <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
